import type { ApplyProtocolInput } from '../../api/protocol.api';

/** `budget`: solo presupuesto (por defecto). `tasks`: presupuesto + plan de producción + tareas. */
export type ApplyMode = 'budget' | 'tasks';

export interface ApplyFormValues {
  loteId: string;
  moduleId: string;
  projectId: string;
  plantingDate: string;
  hectareas: string;
  ciclo: string;
  ranchoId?: string;
}

/** Cuerpo de POST /api/protocols/:id/apply. Zona, proyecto y fecha solo viajan con la opción de tareas. */
export function buildApplyInput(mode: ApplyMode, v: ApplyFormValues): ApplyProtocolInput {
  const base: ApplyProtocolInput = {
    loteId: v.loteId.trim(),
    ranchoId: v.ranchoId,
    hectareas: parseFloat(v.hectareas) || 0,
    ciclo: v.ciclo.trim(),
  };
  if (mode === 'budget') return base;
  return { ...base, moduleId: v.moduleId, projectId: v.projectId, plantingDate: v.plantingDate };
}
